

export class SymbolData {

    public level:number = -1;
    public multiplierString:string = "";
    public symbolMultipliers:{M1:number, M2:number, M3:number, M4:number, M5:number} = {
        M1: -1,
        M2: -1,
        M3: -1,
        M4: -1,
        M5: -1,
    };
    public symbolsToM1:string [] = [];
    public currentMode:string = "";


    constructor() {}

    // TODO: Symbols to M1, symbols are replaced. Server
    public determineTransform(symName:string):boolean {
        const bool:boolean = (this.symbolsToM1.indexOf(symName) > -1);

        if(symName === "M1") {
            return false;
        }


        if(this.symbolsToM1.length > 0 && (this.currentMode === "FREESPIN_TRANSFORM" || this.currentMode === "FREESPIN_COMBINED")) {

            if(bool) {
                //console.log("------------------ TRANSFORM ON SYM: " + symName);
                return bool;
            }
        }

        return false;
    }

    public determineLastMultiplier(symName:string):number {
        //let nr:number
        //debugger;
        if(this.symbolMultipliers && (this.currentMode === "FREESPIN_MULTIPLIER" || this.currentMode === "FREESPIN_COMBINED") && ["M1", "M2", "M3", "M4", "M5"].indexOf(symName) > -1) {
            switch(symName) {
                case "M1":
                    return this.symbolMultipliers.M1;
                case "M2":
                    return this.symbolMultipliers.M2;
                case "M3":
                    return this.symbolMultipliers.M3;
                case "M4":
                    return this.symbolMultipliers.M4;
                case "M5":
                    return this.symbolMultipliers.M5;
            }

            //return this.symbolMultipliers[symName];
        }

        return -1;
    }

    public reset():void {
        this.level = -1;
        this.multiplierString = "";
        this.symbolMultipliers = {
                M1: -1,
                M2: -1,
                M3: -1,
                M4: -1,
                M5: -1,
            };

        // TODO: symbolsToM1: use
        this.symbolsToM1 = [];
            this.currentMode = "";
    }
}